import { debounce } from 'lodash';
import React, { FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setAgent, updateProps } from '../../../contextRedux/Agent/AgentModel';
import { SearchInput } from '../../../customComponents/input/SearchInput';
import { CustomTable } from '../../../customComponents/table/CustomTable';
import { RootState } from '../../../store';
import { AgentColumn } from './AgentColumn';

const AgentTable: FC<any> = () => {
  const dispatch = useDispatch();

  const reduxAgent = useSelector((state: RootState) => state.models?.agent);
  const agents = useSelector((state: RootState) => state.store?.agent.data);

  const pageSizes = [10, 20, 30, 50];
  const currentPage = Math.floor(reduxAgent.props.skip / reduxAgent.props.take) + 1;

  const debouncedSearch = useCallback(
    debounce((value: string) => {
      dispatch(updateProps({ field: 'searchTerm', value }));
      dispatch(updateProps({ field: 'skip', value: 0 }));
    }, 500),
    [dispatch]
  );

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    debouncedSearch(e.target.value);
  };

  const handleEdit = (record: any) => {
    dispatch(setAgent(record));
    dispatch(updateProps({ field: 'isModalVisible', value: true }));
  };

  const paginationConfig = {
    current: currentPage,
    pageSize: reduxAgent.props.take,
    total: reduxAgent.props.totalItems,
    onChange: (page: number, pageSize: number) => {
      const skipValue = (page - 1) * pageSize;
      dispatch(updateProps({ field: 'skip', value: skipValue }));
      dispatch(updateProps({ field: 'take', value: pageSize }));
    },
    showSizeChanger: true,
    pageSizeOptions: pageSizes.map((size) => size.toString()),
    onShowSizeChange: (_current: number, size: number) => {
      dispatch(updateProps({ field: 'skip', value: 0 }));
      dispatch(updateProps({ field: 'take', value: size }));
    },
    showQuickJumper: false,
  };
  return (
    <>
      <SearchInput
        placeholder='Search...'
        defaultValue={reduxAgent.props.searchTerm}
        onChange={handleSearch}
        style={{ marginBottom: 10 }}
      />
      <CustomTable
        initialDataSource={agents ?? []}
        pagination={paginationConfig}
        columns={AgentColumn(handleEdit)}
        rowKey='id'
      />
    </>
  );
};

export default AgentTable;
